import React, { useEffect } from "react";
import Router from "./routes";
import ThemeProvider from "./theme";
import ScrollToTop from "./components/scroll-to-top";
import ModalProvider from "./components/modal/modal";
import { Backdrop } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setModalState } from "./redux/actions/modalActions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logoImg from "./assets/logo/logo-hd.png";
import {
  loadingBtn2Action,
  loadingBtnAction,
  loadingAction,
} from "./redux/actions/userActions";
import {
  setEtsyListingsActiveLoading,
  setEtsyListingsInactiveLoading,
  setEtsyListingsDraftLoading,
  setEtsyResyncActiveLoading,
  setEtsyResyncInactiveLoading,
  setEtsyResyncDraftLoading,
} from "./redux/actions/productActions";

export default function App() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  useEffect(() => {
    // Reset all loading states on app initialization (intentional: run once on mount)
    dispatch(loadingAction(false));
    dispatch(loadingBtnAction(false));
    dispatch(loadingBtn2Action(false));
    
    // Reset Etsy listing loading states on page reload
    dispatch(setEtsyListingsActiveLoading(false));
    dispatch(setEtsyListingsInactiveLoading(false));
    dispatch(setEtsyListingsDraftLoading(false));
    dispatch(setEtsyResyncActiveLoading(false));
    dispatch(setEtsyResyncInactiveLoading(false));
    dispatch(setEtsyResyncDraftLoading(false));
    
    if (isAuthenticated) {
      dispatch(setModalState(undefined));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        limit={3}
        newestOnTop
      />
      <ModalProvider />
      <ScrollToTop />
      {isLoading && (
        <div className="loader">
          <Backdrop sx={{ zIndex: 2000 }} open={true}>
            <div
              className="logo-loader"
              style={{ backgroundImage: `url(${logoImg})` }}
              role="img"
              aria-label="Loading"
            />
          </Backdrop>
        </div>
      )}

      <Router />
    </ThemeProvider>
  );
}
